export default __webpack_public_path__ + "images/sweep1.d9fd248f61f09745cf914902fdd6773a.png";